import React, { Children, Fragment } from 'react'

export function CellsWithSpacer ({ children }: { children: React.ReactNode }) {
  const count = Children.count(children)

  return (
    <>
      {Children.map(children, (child, index) => (
        <Fragment key={index}>
          {child}
          {index < count - 1 && <td aria-hidden className='w-3 min-w-3' />}
        </Fragment>
      ))}
    </>
  )
}
